import Actions from '../actions.js';
import Dispatcher from '../dispatcher.js';
export class BaseController {
    constructor() {
        Object.defineProperty(this, "initialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
    }
    register(listener) {
        Dispatcher.subscribe(listener);
    }
    unregister(listener) {
        Dispatcher.unsubscribe(listener);
    }
    getDispatcher() {
        return Dispatcher;
    }
    initialize() {
        this.initialized = true;
        Dispatcher.dispatch({ type: Actions.INITIALIZED, payload: {} });
    }
}
